import { withStyles } from '@mui/styles';

import { muiStyles } from './styles';
import { UserMenu } from './userMenu';

export default withStyles(muiStyles)(UserMenu);